module.exports = __webpack_public_path__ + "assets/img/17_1043_big.eb77a4de.jpg";